var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('th',[_vm._v("Gxptest")]),_c('th',[_vm._v("Gxpdate")]),_c('th',[_vm._v("Gxpres")])])}
var staticRenderFns = []

export { render, staticRenderFns }